<script setup>
import { ref } from "vue"
import { useQuery } from "@vue/apollo-composable"
import RegisterUser from "@/pages/auth/RegisterUser.vue"
import { useToggleThemeStore } from "@/stores/toggleTheme"

import COUNTRIES_QUERY from "@/graphql/Country/CountriesQuery.gql"
import TAGS_QUERY from "@/graphql/Tag/TagsQuery.gql"

const themeStore = useToggleThemeStore()
const { toggleTheme } = themeStore

//queries
const {
  result: countries,
  loading: countryLoading,
  error: countryError,
} = useQuery(COUNTRIES_QUERY)
const {
  result: tags,
  loading: tagsLoading,
  error: tagsError,
} = useQuery(TAGS_QUERY, {
  first: 999,
  filters: {},
})
</script>

<template>
    <div class="panel max-w-lg mx-auto my-12 text-sm">
      <div class="mx-auto w-full my-8">
        <a href="https://www.ytz.com/">
          <img
            class="mx-auto h-14 w-auto rounded-[0.25rem]"
            src="@/assets/images/ytz-logo.svg"
            alt="YTZ company logo"
        /></a>
      </div>

      <div class="panel-body !bg-base-200">
        <RegisterUser
          :countries="countries"
          :tags="tags"
        />
      </div>
    </div>
</template>
